
import { getGeoCountry, getGeoPrices } from "./utilities";

document.body.addEventListener('click', (event) => {
    if (event.target && event.target.parentElement &&
        event.target.parentElement.classList.contains('wg-li') &&
        !event.target.parentElement.classList.contains('wgcurrent')
    ) {
        // Need to make sure that we set the language in a cookie before 
        // WEGOT redirects to language page
        const date = new Date();
        date.setTime(date.getTime() + 2592000000);

        document.cookie = 'language-choice=' + event.target.parentElement.dataset.codeLanguage + '; path=/; Secure; expires=' + date.toUTCString();
    }
});

export async function loadGeo() {
    const geoCountry = await getGeoCountry();

    const geoLanguageBar = document.querySelector('[data-behaviour="geo-language-bar"]');
    if (geoLanguageBar !== null) {
        const currentLanguage = 'currentLanguage' in geoLanguageBar.dataset
            ? geoLanguageBar.dataset.currentLanguage
            : 'en';
        const geoLanguageBarAddition = geoLanguageBar.querySelector('[data-target="geo-language-bar-addition"]');
        const geoLanguageBarTitle = geoLanguageBar.querySelector('[data-target="geo-language-bar-title"]');
        const geoLanguageBarOptions = geoLanguageBar.querySelector('[data-target="geo-language-bar-options"]');
        const geoLanguageBarUsOption = geoLanguageBar.querySelector('[data-language="English"]');
    
        if (currentLanguage == 'en') {
            if (geoCountry.country === 'US' && geoLanguageBarUsOption !== null) {
                geoLanguageBarOptions.value = geoLanguageBarUsOption.value;
            }

            if (geoLanguageBarAddition !== null) {
                if (geoCountry.country === 'US' && 'textUs' in geoLanguageBarAddition.dataset) {
                    geoLanguageBarAddition.innerHTML = geoLanguageBarAddition.dataset.textUs;
                    geoLanguageBar.classList.remove('u-hidden');
                }
            }

            if (geoLanguageBarTitle !== null) {
                if (geoCountry.country === 'US' && 'textUs' in geoLanguageBarTitle.dataset) {
                    geoLanguageBarTitle.innerHTML = geoLanguageBarTitle.dataset.textUs;
                    geoLanguageBar.classList.remove('u-hidden');
                }
            }
        } else if (currentLanguage == 'en-us') {
            if (geoLanguageBarAddition !== null) {
                if (geoCountry.country === 'GB' && 'textGb' in geoLanguageBarAddition.dataset) {
                    geoLanguageBarAddition.innerHTML = geoLanguageBarAddition.dataset.textGb;
                    geoLanguageBar.classList.remove('u-hidden');
                } else if (geoCountry.country !== 'US' && 'textOther' in geoLanguageBarAddition.dataset) {
                    geoLanguageBarAddition.innerHTML = geoLanguageBarAddition.dataset.textOther;
                    geoLanguageBar.classList.remove('u-hidden');
                }
            }

            if (geoLanguageBarTitle !== null) {
                if (geoCountry.country === 'GB' && 'textGb' in geoLanguageBarTitle.dataset) {
                    geoLanguageBarTitle.innerHTML = geoLanguageBarTitle.dataset.textGb;
                    geoLanguageBar.classList.remove('u-hidden');
                } else if (geoCountry.country !== 'US' && 'textOther' in geoLanguageBarTitle.dataset) {
                    geoLanguageBarTitle.innerHTML = geoLanguageBarTitle.dataset.textOther;
                    geoLanguageBar.classList.remove('u-hidden');
                }
            }
        }
    }

    const geoPictures = document.querySelectorAll('[data-behaviour="geo-pictures"]');
    if (geoPictures.length > 0 && geoCountry.country.toUpperCase() != 'GB') {
        geoPictures.forEach(geoPicture => {
            const imageTarget = geoPicture.querySelector('[data-ref="geo-picture-image-target"]');
            const sourceJumboTarget = geoPicture.querySelector('[data-ref="geo-picture-source-jumbo-target"]');
            const sourceDesktopTarget = geoPicture.querySelector('[data-ref="geo-picture-source-desktop-target"]');
            const sourceTabletTarget = geoPicture.querySelector('[data-ref="geo-picture-source-tablet-target"]');
            const sourceMobileTarget = geoPicture.querySelector('[data-ref="geo-picture-source-mobile-target"]');
            const sourcesDesktop = 'geoDesktopImages' in geoPicture.dataset ? JSON.parse(geoPicture.dataset.geoDesktopImages) : [];
            const sourcesMobile = 'geoMobileImages' in geoPicture.dataset ? JSON.parse(geoPicture.dataset.geoMobileImages) : [];
            const loader = geoPicture?.parentElement !== null
                ? geoPicture?.parentElement.querySelector('[data-ref="geo-loading-spinner"]')
                : null;

            if (loader !== null) {
                loader.classList.remove('u-hidden');
            }

            if (imageTarget !== null && (sourcesDesktop.length > 0 || sourcesMobile.length > 0)) {
                let sourceJumbo = '';
                let sourceDesktop = '';
                let sourceTablet = '';
                let sourceMobile = '';

                if (sourcesMobile.length > 0) {
                    for (const source of sourcesMobile) {
                        if (source.country_codes.includes(geoCountry.country.toUpperCase())) {
                            if (sourceTabletTarget !== null) {
                                sourceTablet = source.source_tablet;
                            }

                            if (sourceMobileTarget !== null) {
                                sourceMobile = source.source_mobile;
                            }
                            break;
                        }
                    }
                }

                if (sourcesDesktop.length > 0) {
                    for (const source of sourcesDesktop) {
                        if (source.country_codes.includes(geoCountry.country.toUpperCase())) {
                            imageTarget.setAttribute('src', source.source_desktop);
                            imageTarget.setAttribute('width', source.width_desktop);
                            imageTarget.setAttribute('height', source.height_desktop);

                            if (sourceJumboTarget !== null) {
                                sourceJumbo = source.source_jumbo;
                            }

                            if (sourceDesktopTarget !== null) {
                                sourceDesktop = source.source_desktop;
                            }

                            if (sourceTabletTarget !== null && sourceTablet == '') {
                                sourceTablet = source.source_tablet;
                            }

                            if (sourceMobileTarget !== null && sourceMobile == '') {
                                sourceMobile = source.source_mobile;
                            }
                            break;
                        }
                    }
                }

                if (sourceJumbo != '') {
                    sourceJumboTarget.setAttribute('srcset', sourceJumbo);
                }

                if (sourceDesktop != '') {
                    sourceDesktopTarget.setAttribute('srcset', sourceDesktop);
                }

                if (sourceTablet != '') {
                    sourceTabletTarget.setAttribute('srcset', sourceTablet);
                }

                if (sourceMobile != '') {
                    sourceMobileTarget.setAttribute('srcset', sourceMobile);
                }
            }

            if (loader !== null) {
                loader.classList.add('u-hidden');
            }
        });
    }

    const geoPrices = document.querySelectorAll('[data-behaviour*="geo-price"]');
    if (geoPrices.length > 0) {
        let prices = Array.from(geoPrices, geoPrice => geoPrice.innerHTML.replace(/,/g, ''))
        prices = await getGeoPrices(prices);
        if (prices.length > 0) {
            geoPrices.forEach((geoPrice, index) => {
                if (index in prices) {
                    geoPrice.innerHTML = prices[index];
                }
            });
        }
    }
}

if (document.readyState !== 'loading') {
	loadGeo();
} else {
	document.addEventListener('DOMContentLoaded', loadGeo);
}
